import { localeConfig } from "src/config/locales";
import type { MedusaProduct, Locale } from "src/types/index.ts";

export const getProductPrice = (product: MedusaProduct) => {
  const productWithPrices = product.variants.find(
    (variant) => variant.prices.length > 0,
  );
  return (
    productWithPrices?.prices.find((price) => price.currency_code === "usd")
      ?.amount ?? null
  );
};

export const getPrice = (
  product: MedusaProduct | null,
  defaultPrice: number,
) => {
  const price = (product ? getProductPrice(product) : null) ?? defaultPrice;

  return price / 100;
};

export const getCurrencyFormatter = (locale: Locale) => {
  const config = localeConfig[locale];
  const options: Intl.NumberFormatOptions = {
    style: "currency",
    minimumFractionDigits: config.fractionDigits,
    currency: config.currency,
  };

  return new Intl.NumberFormat(config.locale, options);
};
